"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isIterableEmtpy(iterable) {
    if (iterable) {
        for (let element of iterable) {
            return false;
        }
    }
    return true;
}
exports.isIterableEmtpy = isIterableEmtpy;
//# sourceMappingURL=IsIterableEmpty.js.map